import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const InnerWrapper = styled.div`
  max-width: 65vw;
  margin: 1rem auto;
  scroll-behavior: smooth;
  @media (max-width: ${defaultBreakpoints.medium}) {
    max-width: 95vw;
  }
`;
